export const assetClassConfigUrl = "config/asset-classes";
export const assetCategoryConfigUrl = "config/asset-categories";
export const assetTypeConfigUrl = "config/asset-types";
export const assetSubTypeConfigUrl = "config/asset-subtypes";
export const assetHierarchyConfigUrl = "config/hierarchy";
export const regionConfigUrl = "config/regions";
export const subRegionConfigUrl = "config/subregions";
export const criticalityConfigUrl = "config/criticality";
export const assetHealthConfigUrl = "config/asset-factors";
export const assetSizeConfigUrl = "config/asset-sizes";
export const assetInfoFieldConfigUrl = "config/asset-info-fields";
export const assetCategorySpatialConfigUrl = "config/spatial/asset-categories";
export const assetFactorUrl = "asset-factors";
export const assetSizeUrl = "asset-sizes";
export const snapshotUrl = "asset-snapshots";
export const snapshotWriteUrl = "request-write";
export const snapshotReadUrl = "request-read";
export const snapshotColumnUrl = "columns";
export const transformationRuleUrl = "transformation-rules";
export const calculationRuleUrl = "calculation-rules";
export const swapRequestUrl = "swap-request";
export const modelUrl = "models";
export const builderUrl = "builder";
export const scenarioUrl = "scenarios";
export const mandatoryTreatmentUrl = "mandatory-treatments";
export const tagUrl = "tags";
export const jobUrl = "jobs";
export const resultsUrl = "results";
export const dataSeriesUrl = "data-series";
export const dashboardUrl = "dashboards";
export const assetCategoriesUrl = "asset-categories";
export const publishRequestUrl = "publish-request";
export const dataUrl = "data";
export const dataCount = "data-count";
export const nexusUrl = "nexus-snapshots";
export const lifecycleTemplateUrl = "templates/lifecycle";
export const nexusTemplateUrl = "templates/nexus-snapshots";
export const nexusSnapshotUrl = "nexus-snapshots";
export const resourceUrl = "me/resources";
export const userUrl = "me";
export const tenantUrl = "tenants";
export const portfolioUrl = "portfolios";
export const memberUrl = "members";
export const planUrl = "plans";
export const planAttributesUrl = "attributes";
export const planDocumentUrl = "plan-documents";
export const planDocumentCreateUrl = "plan-documents/create-request";
export const planDocumentPreviewUrl = "plan-documents/preview-request";
export const downloadRequestUrl = "download-request";
export const tenantHealthBinUrl = "config/health-bins";
export const assetCategoryHealthBinUrl = "config/asset-categories/health-bins";
export const healthBinUrl = "health-bins";
export const entitlementUrl = "entitlements";
export const featuresUrl = "features";
export const summaryUrl = "summaries";
export const modelSummaryUrl = "model-summaries";
export const reportUrl = "reports";
export const entityUrl = "entities";
export const histogramUrl = "histogram";
export const infoUrl = "info";
export const entityReportUrl = "entity-reports";
export const exportUrl = "export";
export const digitalPlanUrl = "digital-plans";
export const configurationsUrl = "configurations";
export const gapIndexUrl = "gap-index";
export const narrativeUrl = "narratives";
export const promptResponseUrl = "prompt-response";
export const generateNarrativeRequest = "generate-response-request";

export const generateJobUrl = (jobId: string) => `${jobUrl}/${jobId}`;
export const generateModelJobUrl = (modelId: string) =>
  `${modelUrl}/${modelId}/${jobUrl}`;
export const generateModelScenarioJobUrl = (
  modelId: string,
  scenarioId: string,
) => `${modelUrl}/${modelId}/${scenarioUrl}/${scenarioId}/${jobUrl}`;
export const generateJobSummaryUrl = (jobId: string) =>
  `${jobUrl}/${jobId}/${summaryUrl}/${dataUrl}`;
export const generateModelJobSummaryUrl = (jobId: string) =>
  `${jobUrl}/${jobId}/${modelSummaryUrl}`;

export const generateSnapshotColumnsUrl = (snapshotId: string) =>
  `${snapshotUrl}/${snapshotId}/${snapshotColumnUrl}`;
export const generateAssetCategoryConfigSnapshotUrl = (
  assetCategoryId: string,
) =>
  `${assetCategoryConfigUrl}/${assetCategoryId}/${snapshotUrl}?sortDesc=true`;
export const generateAssetCategoryTransformationRulesUrl = (
  assetCategoryId: string,
) => `${assetCategoryConfigUrl}/${assetCategoryId}/${transformationRuleUrl}`;
export const generateAssetCategoryTransformationRuleUrl = (
  assetCategoryId: string,
  ruleId: string,
) =>
  `${assetCategoryConfigUrl}/${assetCategoryId}/${transformationRuleUrl}/${ruleId}`;
export const generateAssetCategoryCalculationRulesUrl = (
  assetCategoryId: string,
) => `${assetCategoryConfigUrl}/${assetCategoryId}/${calculationRuleUrl}`;
export const generateAssetCategoryCalculationRuleUrl = (
  assetCategoryId: string,
  ruleId: string,
) =>
  `${assetCategoryConfigUrl}/${assetCategoryId}/${calculationRuleUrl}/${ruleId}`;

export const generateTenantMembersUrl = (tenantId: string) =>
  `${tenantUrl}/${tenantId}/${memberUrl}`;
export const generateTenantMemberUrl = (tenantId: string, memberId: string) =>
  `${tenantUrl}/${tenantId}/${memberUrl}/${memberId}`;
export const generateTenantPortfoliosUrl = (tenantId: string) =>
  `${tenantUrl}/${tenantId}/${portfolioUrl}`;

export const generatePortfolioMembersUrl = (portfolioId: string) =>
  `${portfolioUrl}/${portfolioId}/${memberUrl}`;
export const generatePortfolioMemberUrl = (
  portfolioId: string,
  memberId: string,
) => `${portfolioUrl}/${portfolioId}/${memberUrl}/${memberId}`;

export const generatePlanUrl = (planId: string) => `${planUrl}/${planId}`;
export const generatePlanAttributesUrl = (planId: string) =>
  `${planUrl}/${planId}/${planAttributesUrl}`;
export const generatePlanAttributeUrl = (planId: string, key: string) =>
  `${planUrl}/${planId}/${planAttributesUrl}/${key}`;
export const generatePlanDocumentDownloadUrl = (documentId: string) =>
  `${planDocumentUrl}/${documentId}/${downloadRequestUrl}`;

export const generateDigitalPlanUrl = (planId: string) =>
  `${digitalPlanUrl}/${planId}`;
export const generatePlanNarrativesUrl = (planId: string) =>
  `${digitalPlanUrl}/${planId}/${narrativeUrl}`;
export const generatePlanNarrativeUrl = (planId: string, key: string) =>
  `${digitalPlanUrl}/${planId}/${narrativeUrl}/${key}`;
export const generateNarrativePromptResponseUrl = (
  planId: string,
  key: string,
) => `${digitalPlanUrl}/${planId}/${narrativeUrl}/${key}/${promptResponseUrl}`;
export const generateGenerateNarrativesUrl = (planId: string) =>
  `${digitalPlanUrl}/${planId}/${narrativeUrl}/${generateNarrativeRequest}`;

export const generateAssetCategoryHealthBinUrl = (assetCategoryId: string) =>
  `${assetCategoryConfigUrl}/${assetCategoryId}/${healthBinUrl}`;
export const generateAssetCategoryFactorUrl = (assetCategoryId: string) =>
  `${assetCategoryConfigUrl}/${assetCategoryId}/${assetFactorUrl}`;
export const generateAssetCategorySizeUrl = (assetCategoryId: string) =>
  `${assetCategoryConfigUrl}/${assetCategoryId}/${assetSizeUrl}`;
